var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlassware(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "27px",
    viewBox: "0 0 92 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-version-Copy",
    transform: "translate(-142.000000, -97.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(140.000000, 97.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pint"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-16",
    fillOpacity: 0,
    fill: "#D8D8D8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "inner",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "5.4 9.3 21.6 9.3 19.8 24.6 7.2 24.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4,0 L21.6,0 L24.3,0 L22.5,27 L4.5,27 L2.7,0 L5.4,0 Z M21.4,2.7 L5.60014648,2.7 L7.20131836,24.3 L19.8,24.3 L21.4,2.7 Z",
    id: "outer",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gobblet",
    transform: "translate(34.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-16",
    fillOpacity: 0,
    fill: "#D8D8D8",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4,0 L21.6,0 L24.3,0 L24.3,10.8 C24.3,16.1513933 20.407884,20.5937342 15.3,21.4506748 L15.3,24.3 L20.7,24.3 L20.7,27 L6.3,27 L6.3,24.3 L11.7,24.3 L11.7,21.4506748 C6.59211599,20.5937342 2.7,16.1513933 2.7,10.8 L2.7,0 L5.4,0 Z M5.4,2.7 L5.4,10.8 C5.4,15.2735065 9.02649353,18.9 13.5,18.9 C17.9735065,18.9 21.6,15.2735065 21.6,10.8 L21.6,2.7 L5.4,2.7 Z",
    id: "Oval-1",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,8.56635284 C21.8905083,9.36342275 22.05,10.2151418 22.05,11.1 C22.05,15.5735065 17.9735065,19.2 13.5,19.2 C9.02649353,19.2 4.95,15.5735065 4.95,11.1 C4.95,10.2151418 5.10949166,9.36342275 5.4,8.56635284 L5.4,9.3 L21.6,9.3 L21.6,8.56635284 Z",
    id: "Oval-5",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glencairn",
    transform: "translate(69.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-16",
    fillOpacity: 0,
    fill: "#D8D8D8",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4,9.3 L21.6,9.3 L21.6,19.2479004 C21.6,19.2479004 16.1452881,23.8151367 13.5,23.8151367 C10.7452881,23.8151367 5.4,19.2479004 5.4,19.2479004 L5.4,9.3 Z",
    id: "Rectangle-15",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77957659,-6.4332129e-12 C7.72194436,3.56076661 6.19200928,8.69148213 5.59210628,11.6883092 C5.46993266,12.2986299 5.41380284,12.885544 5.41969761,13.4476998 C5.40663843,13.6037367 5.4,13.7612406 5.4,13.9200308 C5.4,17.6314013 8.40289307,21.5990112 13.5,21.5990112 C18.5971069,21.5990112 21.6,17.6314013 21.6,13.9200308 C21.6,13.7612406 21.5933616,13.6037367 21.5803024,13.4476998 C21.5861972,12.885544 21.5300673,12.2986299 21.4078937,11.6883092 C20.8270899,8.78689246 19.3495689,3.59733105 19.1542381,-6.47559393e-12 L20.201952,-6.26121377e-12 C20.6393034,0.000505364363 21.0011425,0.000969495574 21.2429341,0.00129164477 C21.29862,0.00136583745 21.3479385,0.00143249932 21.3903456,0.00149039969 C21.5076715,0.00165059007 21.5720948,0.00174371655 21.5720948,0.00174371655 C21.9201993,4.23033172 23.2022705,8.1450227 24.0312813,12.2863619 C24.9799555,17.0254825 22.9384934,20.704869 18.9679023,22.9676726 C18.7078982,23.1158466 20.5743954,26.6187089 20.5661829,27 L13.5321613,27 C13.5213867,26.9837333 13.5106663,26.9673332 13.5,26.9508006 C13.4893337,26.9673332 13.4786133,26.9837333 13.4678387,27 L6.43381707,27 C6.42560461,26.6187089 8.29210183,23.1158466 8.03209765,22.9676726 C4.06150656,20.704869 2.02004452,17.0254825 2.96871875,12.2863619 C3.79772948,8.1450227 5.10671722,4.23033172 5.45482172,0.00174371655 C5.45482172,0.00174371655 6.00620698,0.000943758278 6.82002832,7.18662911e-12 L7.77957659,-6.26121377e-12 Z",
    id: "Path-4",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-21",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    x: 6.3,
    y: 0,
    width: 14.4,
    height: 2.7
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassware);
export default __webpack_public_path__ + "static/media/glassware.6759be878dfa021c986fcdd7b9b53776.svg";
export { ForwardRef as ReactComponent };